import { IApplicationState } from '../types/redux';

export function getChartsLoading(state: IApplicationState) {
  return state.charts.loading;
}
